import { useState, useEffect } from 'react';

/**
 * Hook para detectar se a tela atual é considerada mobile.
 * @param breakpoint Largura em pixels (padrão: 768)
 */
export const useIsMobile = (breakpoint: number = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Adiciona o listener
    window.addEventListener('resize', handleResize);

    // Dispara uma vez para garantir o estado inicial correto
    handleResize();

    // Remove o listener ao desmontar
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};